module.exports = __webpack_public_path__ + "img/geo-icon.b2c5ee02.png";